import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { areaService } from '../../services/areas/areaService'
import { UpdateAreaForm } from '../../types'

export const useAreas = (page?: number, limit?: number, activeOnly = false) => {
  return useQuery({
    queryKey: ['areas', page, limit, activeOnly],
    queryFn: () => areaService.getAllAreas(page, limit, activeOnly),
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

export const useArea = (id: string) => {
  return useQuery({
    queryKey: ['area', id],
    queryFn: () => areaService.getArea(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

export const useCreateArea = () => {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: areaService.createArea,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['areas'] })
    },
  })
}

export const useUpdateArea = () => {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateAreaForm }) => 
      areaService.updateArea(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['areas'] })
    },
  })
}

export const useDeleteArea = () => {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: areaService.deleteArea,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['areas'] })
    },
  })
}
